// Shared with analytics without importing the translation runtime or catalogs.
export const getLocaleCookieName = () =>
  document.querySelector<HTMLMetaElement>('meta[name="rhino-locale"]')?.dataset
    .cookieName || 'rhino_locale';
